import { RichTextNodeType, } from '@dossierhq/core';
import { addClassNamesToElement } from '@lexical/utils';
import { $getSelection, $isElementNode, $isRangeSelection, createCommand, ElementNode, } from 'lexical';
function $createAdminEntityLinkNode(reference) {
    return new AdminEntityLinkNode(reference);
}
export function $isAdminEntityLinkNode(node) {
    return node instanceof AdminEntityLinkNode;
}
export const TOGGLE_ADMIN_ENTITY_LINK_COMMAND = createCommand();
export class AdminEntityLinkNode extends ElementNode {
    __reference;
    static getType() {
        return RichTextNodeType.entityLink;
    }
    static clone(node) {
        return new AdminEntityLinkNode(node.__reference, node.__key);
    }
    constructor(reference, key) {
        super(key);
        this.__reference = reference;
    }
    setReference(reference) {
        const self = this.getWritable();
        self.__reference = reference;
    }
    getReference() {
        const self = this.getLatest();
        return self.__reference;
    }
    static importJSON(serializedNode) {
        const node = $createAdminEntityLinkNode(serializedNode.reference);
        node.setFormat(serializedNode.format);
        node.setIndent(serializedNode.indent);
        node.setDirection(serializedNode.direction);
        return node;
    }
    exportJSON() {
        return {
            ...super.exportJSON(),
            type: RichTextNodeType.entityLink,
            reference: this.__reference,
            version: 1,
        };
    }
    createDOM(config, _editor) {
        const element = document.createElement('a');
        addClassNamesToElement(element, config.theme.link);
        return element;
    }
    updateDOM(_prevNode, _dom, _config) {
        return false; // no need to recreate the DOM
    }
    canInsertTextBefore() {
        return false;
    }
    canInsertTextAfter() {
        return false;
    }
    canBeEmpty() {
        return false;
    }
    isInline() {
        return true;
    }
}
export function toggleEntityLink(reference) {
    const selection = $getSelection();
    if (!$isRangeSelection(selection)) {
        return;
    }
    const selectionNodes = selection.extract();
    if (!reference) {
        // Remove all entity links
        replaceParentNodesWithChildren(selectionNodes, $isAdminEntityLinkNode);
    }
    else {
        if (selectionNodes.length === 1) {
            const firstNode = selectionNodes[0];
            // Update the entity link reference of first or parent node
            const entityLinkNode = $isAdminEntityLinkNode(firstNode)
                ? firstNode
                : $getLinkAncestor(firstNode);
            if (entityLinkNode !== null) {
                entityLinkNode.setReference(reference);
                return;
            }
        }
        let prevParent = null;
        let entityLinkNode = null;
        selectionNodes.forEach((node) => {
            const parent = node.getParent();
            if (parent === entityLinkNode ||
                parent === null ||
                ($isElementNode(node) && !node.isInline())) {
                return;
            }
            if ($isAdminEntityLinkNode(parent)) {
                entityLinkNode = parent;
                parent.setReference(reference);
                return;
            }
            if (!parent.is(prevParent)) {
                prevParent = parent;
                entityLinkNode = $createAdminEntityLinkNode(reference);
                if ($isAdminEntityLinkNode(parent)) {
                    if (node.getPreviousSibling() === null) {
                        parent.insertBefore(entityLinkNode);
                    }
                    else {
                        parent.insertAfter(entityLinkNode);
                    }
                }
                else {
                    node.insertBefore(entityLinkNode);
                }
            }
            if ($isAdminEntityLinkNode(node)) {
                if (node.is(entityLinkNode)) {
                    return;
                }
                if (entityLinkNode !== null) {
                    const children = node.getChildren();
                    for (let i = 0; i < children.length; i++) {
                        entityLinkNode.append(children[i]);
                    }
                }
                node.remove();
                return;
            }
            if (entityLinkNode !== null) {
                entityLinkNode.append(node);
            }
        });
    }
}
function replaceParentNodesWithChildren(nodes, predicate) {
    for (const node of nodes) {
        const parent = node.getParent();
        if (parent && predicate(parent)) {
            const children = parent.getChildren();
            for (let i = 0; i < children.length; i++) {
                parent.insertBefore(children[i]);
            }
            parent.remove();
        }
    }
}
function $getLinkAncestor(node) {
    return $getAncestor(node, $isAdminEntityLinkNode);
}
function $getAncestor(node, predicate) {
    let parent = node;
    while (parent !== null && (parent = parent.getParent()) !== null && !predicate(parent))
        ;
    return parent;
}
//# sourceMappingURL=AdminEntityLinkNode.js.map